// extracted by mini-css-extract-plugin
export var icon = "_ro-0";